(function () {
  var root = document.documentElement;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var wrap = document.querySelector('.hev-cursor');
  if (!wrap) return;

  var pointer = wrap.querySelector('.hev-cursor__pointer');
  var hand = wrap.querySelector('.hev-cursor__hand');
  var bolts = Array.prototype.slice.call(wrap.querySelectorAll('.hev-cursor__bolt'));
  var imgs = Array.prototype.slice.call(wrap.querySelectorAll('img[data-src]'));
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TARGETS = 'a, button, label, summary, select, [data-claw], [role="button"]';

  /* Hand 1 for 3s on arriving at a target, then Hand 2 + bolts for 2s, then
     Hand 1 for 15s between every later flash. Moving straight from one target to
     the next keeps the clock running; leaving resets it. */
  var FIRST_DELAY = 3000;
  var REPEAT_DELAY = 15000;
  var FLASH_DURATION = 2000;

  /* Answer Me Aquamarine, Later Alligator Lilac, Busy Blue, Landline Lemon, Yellowpages Gold. */
  var BOLT_COLORS = ['#a5d5a1', '#f19ef4', '#356aae', '#fce37a', '#f6bc00'];

  var x = 0;
  var y = 0;
  var queued = false;
  var decoded = false;
  var ready = false;
  var onTarget = false;
  var timer = null;
  var queue = [];
  var lastColor = null;

  imgs.forEach(function (img) {
    img.src = img.getAttribute('data-src');
  });

  Promise.all(imgs.map(function (img) {
    return img.decode ? img.decode() : Promise.resolve();
  }))
    .then(function () {
      decoded = true;
    })
    .catch(function () {
      if (window.console && console.warn) console.warn('[home-evergreen] cursor art failed to load; keeping the native cursor');
    });

  /* A shuffled queue, so a bolt never takes the same colour twice in a row. */
  function nextColor() {
    if (!queue.length) {
      queue = BOLT_COLORS.slice().sort(function () { return Math.random() - 0.5; });
      if (queue[queue.length - 1] === lastColor) queue.unshift(queue.pop());
    }
    lastColor = queue.pop();
    return lastColor;
  }

  bolts.forEach(function (bolt) {
    bolt.style.setProperty('--hev-bolt-color', nextColor());
    /* Fires at the loop point, where the bolt is fully transparent. */
    bolt.addEventListener('animationiteration', function () {
      bolt.style.setProperty('--hev-bolt-color', nextColor());
    });
  });

  function setFlash(on) {
    hand.classList.toggle('is-flash', on);
  }

  function scheduleFlash(delay) {
    clearTimeout(timer);
    if (reduceMotion.matches) return;
    timer = setTimeout(function () {
      setFlash(true);
      timer = setTimeout(function () {
        setFlash(false);
        scheduleFlash(REPEAT_DELAY);
      }, FLASH_DURATION);
    }, delay);
  }

  function enter() {
    onTarget = true;
    setFlash(false);
    scheduleFlash(FIRST_DELAY);
  }

  function leave() {
    onTarget = false;
    clearTimeout(timer);
    timer = null;
    setFlash(false);
  }

  function paint() {
    var t = 'translate(' + x + 'px, ' + y + 'px)';
    pointer.style.transform = t;
    hand.style.transform = t;
    queued = false;
  }

  document.addEventListener('mousemove', function (e) {
    if (!decoded) return;
    x = e.clientX;
    y = e.clientY;
    if (!ready) {
      ready = true;
      paint();
      root.classList.add('hev-cursor-ready');
    }
    if (!queued) {
      queued = true;
      requestAnimationFrame(paint);
    }
    var now = !!(e.target.closest && e.target.closest(TARGETS));
    if (now && !onTarget) enter();
    if (!now && onTarget) leave();
    hand.classList.toggle('is-on', now);
    pointer.classList.toggle('is-on', !now);
  }, { passive: true });

  document.documentElement.addEventListener('mouseleave', function () {
    hand.classList.remove('is-on');
    pointer.classList.remove('is-on');
    if (onTarget) leave();
  });
})();
